// RTK Query slice just for account/user
import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "./baseQuery";

export const accountApi = createApi({
  reducerPath: "accountApi",
  baseQuery: dynamicBaseQuery, // <<— dynamic
  refetchOnFocus: false,
  refetchOnReconnect: false,
  keepUnusedDataFor: 300,
  tagTypes: ["Account"],
  endpoints: (builder) => ({
    getAccount: builder.query({
      query: () => ({
        url: "api/account",
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
        noCache: false,
      }),
      providesTags: ["Account"],
    }),
    updateAccount: builder.mutation({
      query: (body) => ({
        url: "api/account/",
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Account"],
    }),
    getCreditSummary: builder.query({
      query: () => ({
        url: "api/giftcard-credits/summary",
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
      }),
      providesTags: ["Account"],
    }),
  }),
});

export const { useGetAccountQuery, useUpdateAccountMutation, useGetCreditSummaryQuery } = accountApi;
